import { css, keyframes } from '@emotion/core'
import {
  CommonTxtBoxStyle,
  FloatingBottom2, SwiperWrap,
  TxtLimit, TxtLimit2,
} from '@styles/base.style'
import { ProfileImgWrapStyle } from '@views/Popup/Chat/index.style'
import styled, { ThemeProps } from '@themes/theme'
import chevronButton from '@assets/images/icon/etc_icon/chevron.png'
import disabledChevronButton from '@assets/images/icon/etc_icon/chevron-disable.png'

const MatchSimpleInfoAni = keyframes`
  0% {
    height: 0;
  }
  100% {
    height: 40px;
  }
`
export const dividendBoardStyle = (props: ThemeProps) => css`
  text-align: center;
  border: 1px solid #A4ABB7;
  background: none;
  width: auto;
  height: 26px;
  line-height: 24px;
  border-radius: 6px;
  box-shadow: inset 1px 1px 0 #eeeeee80, 1px 1px 0 #eeeeee80;
  span{
    display: inline-block;  
    min-width: 40px;
    padding: 0 8px;
    &.none{
      ::after{
        content: '-';
      }
    }
    :nth-child(2){
      border-left: 1px solid #A4ABB7;
      height: 10px;
      line-height: 10px;
      &.is-draw-score{
        border-right: 1px solid #A4ABB7;
      }
    }
  }
`
export const MatchSimpleInfoWrap = styled.div`
  z-index: 2;
  position:sticky;
  top: -1px;
  width: 100%;
  height: auto;
  padding: 0;
  overflow: hidden;
  .bg {
    position:absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    background: ${props => props.theme.color.mainBg};
  }
  .simple-info {
    position: relative;
    opacity: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0;
    overflow: hidden;
    animation: ${MatchSimpleInfoAni} .15s 1 forwards reverse ease-in-out;
    .emblem {
      width: auto;
      height: 24px;
    }
    .team-name {
      ${TxtLimit};
      transform: translateY(1px);
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.themeTxt};
    }
    .home-tag-img {
      position: absolute;
      top: 4px;
      left: 12px;
      width: 20px;
      height: auto;
    }
    &--home-team, &--away-team {
      display: flex;
      align-items: center;
      width: calc(50% - 45px);
    }
    &--home-team {
      .emblem{
        margin-right: 6px;
      }
    }
    &--vs {
      line-height: 3rem;
      transform: translateY(-3px);
      font-size: 40px;
      letter-spacing: -1px;
      color: ${props => props.theme.color.mainColor};
    }
    &--score {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -48%);
      .score-num {
        width: auto;
        font-size: ${props => props.theme.font.xlarge};
        font-size: ${props => props.theme.fontW.bold};
        color: ${props => props.theme.color.disableTxt};
        &.home {
          text-align: right;
        }
        &.away {
          text-align: left;
        }
        &.win {
          color: ${props => props.theme.color.white};
        }
      }
      .score-center {
        margin: 0 7px;
        font-size: ${props => props.theme.font.large};
        transform: translateY(-6%);
        opacity: .5;
      }
    }
    &--away-team {
      justify-content: flex-end;
      .emblem{
        margin-left: 6px;
      }
      .team-name {
        text-align: right;
      }
    }
  }
  &.show-simple-info {
    overflow: visible;
    //height: 40px;
    animation: ${MatchSimpleInfoAni} .15s 1 forwards cubic-bezier(.02,.67,.48,1);
    .simple-info {
      opacity: 1;
      height: 100%;
      padding: 4px 28px 0;
      animation: none;
    }
  }
`
export const VisualNotice = styled.div`
  width: 100%;
  height: auto;
  padding: 4px 0 6px;
  vertical-align: middle;
  text-align: center;
  color: ${props => props.theme.color.disableTxt};
  font-weight: ${props => props.theme.fontW.medium};
  svg {
    width: auto;
    height: 14px;
    transform: translateY(2px);
    margin-right: 4px;
    .fill {
      fill: ${props => props.theme.color.themeTxt};
    }
    .bg {
      fill: ${props => props.theme.color.contentsBg};
    }
  }
`
export const CheerForTeamListItem = styled.div`
  margin: 0 18px;
  padding: 13px 0 16px;
  border-top: 1px solid #50607033;
  display: flex;
  justify-content: space-between;
  &:last-of-type {
    margin-bottom: calc(env(safe-area-inset-bottom) + 200px);
  }
  &.pc {
    :last-of-type {
      margin-bottom: 0;
    }
  }
  .user-profile-btn {
    margin-right: 12px;
    max-width: 30px;
    max-height: 30px;
    transform: translateY(1px);
    .profile-img-wrap {
      ${ProfileImgWrapStyle};
      width: 30px;
      height: 30px;
    }
    &.blocked {
      opacity: .3;
    }
  }
  .contents-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin: 0 auto 0 0;
    width: 100%;
    &:has(.sport-talk-contents:empty) {
      align-content: center;
    }
    .nick-name {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: ${props => props.theme.color.themeTxt};
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.bold};
      .date {
        margin: 0 5px 0 auto;
        white-space: nowrap;
        color: ${props => props.theme.color.contentsBg};
        font-size: ${props => props.theme.font.medium};
        font-weight: ${props => props.theme.fontW.regular};
      }
      .cheer-extra-btn {
        width: 20px;
        height: 20px;
        border-radius: 0;
        img {
          width: 3px;
          height: auto;
          object-fit: cover;
        }
      }
      &.blocked {
        color: ${props => props.theme.color.btn};
      }
    }
    .score-info-wrap {
      display: flex;
      align-items: center;
      margin-left: 1px;
      .score {
        display: flex;
        align-items: center;
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.disableTxt2};
        .emblem {
          margin: 0 2px;
          > img {
            width: auto;
            height: 16px;
          }
        }
      }
      .center {
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.disableTxt2};
        margin: 0 2px;
      }
    }
    .contents {
      width: 100%;
      max-width: 100%;
      position: relative;
      .cheer-for-team-btn {
        position: absolute;
        top: 15px;
        left: 0;
        display: flex;
        width: calc(100vw - 260px);
        min-width: 150px;
        max-width: 186px;
        height: 44px;
        margin-left: 44px;
        border-radius: 0;
        background: ${props => props.theme.color.TP};
        &.pc {
          width: 187px;
        }
      }
      .preview-box {
        width: 100%;
        max-width: 230px;
      }
      .sport-talk-contents {
        ${CommonTxtBoxStyle};
        display: block;
        width: 100%;
        text-align: left;
        color: ${props => props.theme.color.darkTxt};
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.regular};
        margin-top: 6px;
        line-height: 150%;
        > span { // url 대응으로 인해 span 태그 내부에 컨텐츠가 작성되므로 스타일 추가
          ${CommonTxtBoxStyle};
          display: block;
          width: 100%;
          text-align: left;
          color: ${props => props.theme.color.darkTxt};
          font-size: ${props => props.theme.font.large};
          font-weight: ${props => props.theme.fontW.regular};
          line-height: 150%;
        }
        &.blocked {
          color: ${props => props.theme.color.btn};
        }
        .txt {
          font-weight: ${props => props.theme.fontW.medium};
          color: ${props => props.theme.color.modalTxt};  
        }
        .link {
          color: ${props => props.theme.color.blue};
        }
        &.pc {
          .rsme-embed {
            width: 100% !important;
            iframe, .fb-post {
              width: 100% !important;
              min-width: 328px;
            }
          }
        }
        &:empty {
          margin-top: 0;
        }
      }
      .contents--upload {
        display: flex;
        margin-top: 8px;
        background: none;
        .upload-img-preview {
          width: auto;
          max-width: 100%;
          height: auto;
          max-height: 85px;
          &.emoticon {
            height: 78px;
          }
        }
      }
    }
  }
  // 스포츠톡 타임라인
  &.adv-timeline {
    position: relative;
    border-color: ${props => props.theme.color.mainColor};
    padding: 12px 0 18px 0;
    &:has(.sport-talk-contents:empty) {
      padding-top: 18px;
    }
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% + 36px);
      height: 100%;
      background: ${props => props.theme.color.subColor2};
    }
    .profile-img-wrap {
      background: ${props => props.theme.color.mainBg};
      svg {
        width: 25px;
      }
    }
    .nick-name {
      z-index: 1;
      &:not(:has(+ .contents .sport-talk-contents:empty)) {
        height: 21px;
        margin-top: 4px;
      }
      .match-status {
        margin-left: 6px;
      }
      .date {
        color: ${props => props.theme.color.disableBg};
      }
      .emblem {
        width: 16px;
        height: 16px;
      }
      .score {
        margin: 0 3px;
        font-size: ${props => props.theme.font.large};
        &--colon {
          margin: 0 2px;
          font-size: ${props => props.theme.font.large};
        }
      }
    }
  }
`
export const MatchUpDetailPickWrap = styled.div`
  .detail-bet-write-btn {
    margin: 0;
    bottom: calc(${FloatingBottom2} + 13px + 45px);
    right: 18px;
    z-index: 10008; // popover보다 상단에 위치시키기 위해 추가한 코드입니다.
    .write-btn {
      box-shadow: none;
      border: none;
      width: 45px;
      height: 45px;
      backdrop-filter: blur(20px);
      background: none;
      &::after {
        display: none;
      }
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: inherit;
        height: inherit;
        transform: translate(-50%, -50%);
        background: ${props => props.theme.color.btn};
        border-radius: 50%;
        opacity: 0.3;
      }
      .btn-ico {
        z-index: 1;
        .fill {
          fill: ${props => props.theme.color.themeTxt};
        }
      }
    }
    &.pc {
      position: fixed;
      bottom: 40px;
      right: calc(50% - 500px);
    }
  }
  .simple-info {
    display: none;
  }
`
export const MatchUpDetailSportTalkWrap = styled.div`
  .empty-wrap {
    top: calc(40% - 81px) !important; //응원글 입력창 높이
  }
  .am-list-header {
    background: ${props => props.theme.color.mainBg};
  }
`
export const SportIssueListWrap = styled.div`
  width: 100%;
  background: ${props => props.theme.color.mainColor};
  margin-bottom: 10px;
  display: flex;
  flex-flow: column;
  height: 100%;
  .sport-issue-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 18px 18px 12px 19px;
    .tit {
      color: ${props => props.theme.color.themeTxt};
      font-size: ${props => props.theme.font.title};
      font-weight: ${props => props.theme.fontW.bold};
    }
    .all-btn {
      width: auto;
      color: ${props => props.theme.color.disableBg};
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.medium};
    }
  }
`
// 스포츠 이슈(대시보드) 팝업 내 리스트 스타일
export const SportIssuePopupListWrap = styled.div`
  &:first-of-type {
    margin-top: 24px;
  }
  :not(&:last-of-type) {
    &::after {
      display: block;
      content: '';
      width: calc(100% - 140px);
      height: 1px;
      background: ${props => props.theme.color.modalBg};
      margin: 7px 0 7px auto;
    }
  }
  .popular-search-news-btn {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 0;
    background: ${props => props.theme.color.TP};
    flex-wrap: nowrap;
    .thumbnail {
      min-width: 126px;
      width: 126px;
      height: 70px;
      object-fit: cover;
      border-radius: 11px;
      &.embed-wrap {
        width: 126px;
        height: 70px;
        position: relative;
        .rsme-embed {
          border-radius: 22px !important;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: scale(0.5) translate(-100%, -100%);
          pointer-events: none;
          .youtube-iframe {
            height: 100%;
            aspect-ratio: 126/70;
            > iframe {
              height: 100%;
            }
          }
        }
      }
    }
    .title {
      margin-left: 16px;
      ${TxtLimit2};
      text-align: left;
      line-height: 19px;
      max-height: 45px;
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.medium};
    }
  }
`

export const SportIssueCardWrap = styled.div`
  width: 100%;
  .swipe-item {
    margin-bottom: 22px;
  }
  .swiper-slide {
    width: 146px !important;
    &.analysis-profile {
      width: 106px !important;
    }
    .issue-item {
      > img {
        width: 100%;
        height: 82px;
        object-fit: cover;
        border-radius: 11px;
      }
      .embed-wrap {
        width: 146px;
        height: 82px;
        position: relative;
        .rsme-embed {
          border-radius: 22px !important;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: scale(0.5) translate(-100%, -100%);
          pointer-events: none;
          .youtube-iframe {
            height: 100%;
            aspect-ratio: 146/82;
            > iframe {
              height: 100%;
            }
          }
        }
      }
      .contents-txt {
        padding: 0 8px;
        margin-top: 8px;
        ${TxtLimit2};
        max-height: 43px;
        line-height: 2rem;
        color: ${props => props.theme.color.themeTxt};
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.medium};
      }
    }
  }
  &.pc {
    .swiper-wrapper {
      .swipe-item {
        margin-bottom: 0;
      }
      margin-bottom: 52px;
    }
  }
`
export const AnalysisProfileCardWrap = styled.div`
  width: 100%; //분석글 프로필 카드 너비는 .analysis-profile에 정의하였습니다.
  height: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding-block: 12px;
  background: ${props => props.theme.color.subColor2};
  border-radius: 12px;
  .profile {      
    width: 62px;
    aspect-ratio: 1;
    position: relative;
    .profile-img {
      display: block;
      width: 100%;
      aspect-ratio: 1;
      border-radius: 50%;
      overflow: hidden;
      > img {
        width: 100%;
        aspect-ratio: 1;
      }
    }
    > div { // UserPickSpecialMemberMark 컴포넌트 스타일
      bottom: -3px;
      left: -3px;
    }
  }
  .user-nick {
    width: 100%;
    text-align: center;
    margin-block-start: 8px;
    color: ${props => props.theme.color.themeTxt};
    font-size: ${props => props.theme.font.medium};
    font-weight: ${props => props.theme.fontW.medium};
    ::after {
      content: '분석글';
      display: block;
      margin: 0 auto;
      margin-block-start: 3px;
      background: ${props => props.theme.color.mainBg};
      color: ${props => props.theme.color.disableTxt};
      width: 46px;
      height: 18px;
      font-size: ${props => props.theme.font.medium};
      font-weight: ${props => props.theme.fontW.medium};
      line-height: 18px;
      border-radius: 4px;
    }
  }
  &.light-mode {
    background: ${props => props.theme.color.whiteBg};
    box-shadow: 0 2px 4px #00000029;
    .user-nick {
      color: ${props => props.theme.color.modalTxt};
      ::after {
        background: #DDDDDDB3;
        color: ${props => props.theme.color.modalgray};
      }
    }
  }
`

export const ScoreTimelineItemWrap = styled.div`
  width: auto;
  height: 82px;
  aspect-ratio: 146 / 82;
  overflow: hidden;
  border-radius: 11px;
  position: relative; // .emblem-img-bg의 position을 위한 관계설정
  background: ${props => props.theme.color.whiteBg};
  padding: 0 13px 6px 10px;
  .info-txt {
    width: auto;
    height: 32px;
    margin-block: 9px 1px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.half-time {
      height: 38px;
      margin-block: 1px;
    }
    > img {
      width: auto;
      height: 100%;
      object-fit: contain;
      margin-right: auto;
    }
    .time-info {
      width: auto;
      height: 25px;
      border: 1px solid ${props => props.theme.color.modalSubBg};
      padding: 3px 4.5px 2px 6px;
      border-radius: 500px;
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.title};
      font-weight: ${props => props.theme.fontW.bold};
      line-height: ${props => props.theme.font.largeNum};
      transform: translateX(3px);
    }
  }
  .score-time-line-item {
    > span {
      width: 100%;
      display: block;
      text-align: left;
      &.team-name {
        color: ${props => props.theme.color.gray};
        font-size: ${props => props.theme.font.medium};
        font-weight: ${props => props.theme.fontW.medium};
        ${TxtLimit};
      }
      &.player-name {
        color: ${props => props.theme.color.select};
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.bold};
        ${TxtLimit};
      }
    }
    .emblem-img-bg {
      position: absolute;
      bottom: -27px;
      left: -7px;
      width: 75px;
      height: auto;
      > img {
        width: 100%;
        height: auto;
        object-fit: contain;
        opacity: .08;
      }
    }
  }
  .half-time-line-item {
    display: flex;
    align-items: center;
    align-content: center;
    height: 18px;
    width: 100%;
    > span {
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.medium};
      font-weight: ${props => props.theme.fontW.bold};
      transform: translateY(1.5px);
      &.team-name {
        font-weight: ${props => props.theme.fontW.medium};
        max-width: calc(100% - 30px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-inline: 1px auto;
      }
    }
    .emblem-img {
      width: 12px;
      height: 12px;
      object-fit: contain;
    }
  }
  // 대시보드 팝업 내 썸네일 스타일 (SportIssuePopup)
  &.thumbnail {
    background: ${props => props.theme.color.white};
    padding: 0 9.5px 5px 8.5px;
    .info-txt {
      height: 27px;
      margin-block: 7.8px 1.2px;
      &.half-time {
        height: 32px;
        margin-block: 0.5px;
      }
      .time-info {
        height: 22px;
        padding: 1.5px 4px 1.5px 6px;
        font-size: ${props => props.theme.font.large};
      }
    }
    .score-time-line-item {
      > span {
        &.team-name {
          transform: translateY(-2px);
          font-size: ${props => props.theme.font.small};
        }
        &.player-name {
          font-size: ${props => props.theme.font.medium};
        }
      }
      .emblem-img-bg {
        width: 65px;
      }
    }
    .half-time-line-item {
      height: 14px;
      > span {
        font-size: ${props => props.theme.font.small};
        transform: translateY(1.5px);
      }
      .emblem-img {
        width: 10px;
        height: 10px;
      }
    }
  }
  // 매치업 / 라이브 / 경기결과 내 미리보기 스타일 (SportTalkIssuePreview)
  &.timeline-preview {
    width: 120px;
    height: 68px;
    transform: scale(0.5) translate(-50%, -50%);
  }
  // 풀팝업 스타일 (SportIssuePopup / SportIssueList)
  &.full-popup {
    width: 146px;
    height: 82px;
    transform: scale(1.5);
    margin-bottom: 22px;
  }
`

// 팝업 스와이프 스타일 - 스포츠이슈 대시보드
export const PopupSwiperWrap = styled(SwiperWrap)`
  width: 100vw;
  height: 100%;
  background-color: transparent;
  position: relative;
  .swiper {
    position: static;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .swiper-slide {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 18px;
  }
  [class*="swiper-button"] {
    display: none;
  }
  .swiper-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    order: 3;
    position: absolute;
    top: auto;
    bottom: calc(96 / 640 * 100%);
    left: 50%;
    transform: translate(-50%, -50%);
    gap: 10px;
    background-color: transparent;
    opacity: 1;
    height: auto;
  }
  .swiper-pagination-bullet {
    display: none;
    width: 8px;
    height: 8px;
    border-radius: 100px;
    background-color: #B7B7B7;
    opacity: 0;
    transform: scale(0);
    flex-shrink: 0;
  }
  [class*="swiper-pagination-bullet-active"] {
    display: inline-block;
  }
  .swiper-pagination-bullet-active {
    background-color: #26AAB8;
    &-main {
      opacity: 1;
      transform: scale(1);
    }
    &-prev,
    &-next {
      opacity: 1;
      transform: scale(1);
      width: 6px;
      height: 6px;
      transition: all 200ms ease-in-out;
    }
    &-prev-prev,
    &-next-next {
      display: none;
    }
  }
  .swiper-wrapper {
    padding-bottom: 20px;
  }
  .swiper-image-wrap,
  .swiper-youtube-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50vh;
    min-height: 300px;
    max-height: 380px;
    overflow: hidden;
  }
  .swiper-image-wrap {
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .swiper-title {
    font-family: 'Noto Sans KR', 'Malgun Gothic', '맑은 고딕', 'Apple SD Gothic Neo', '돋움', dotum, sans-serif !important;
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.medium};
    color: ${props => props.theme.color.themeTxt};
  }
  .swiper-source-button {
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 0 18px;
    border: none;
    outline: none;
  }
  .swiper-source {
    background-color: rgba(111, 119, 126, 0.35);
    border-radius: 30px;
    padding: 3px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-family: 'Noto Sans KR', 'Malgun Gothic', '맑은 고딕', 'Apple SD Gothic Neo', '돋움', dotum, sans-serif !important;
    color: ${props => props.theme.color.modalSubBg};
    font-size: ${props => props.theme.font.medium};
    font-weight: ${props => props.theme.fontW.medium};
    img {
      width: 12px;
      height: 12px;
    }
  }
  &.pc {
    [class*="swiper-button"] {
      display: block;
      top: calc(50% - 35px);
      transform: translateX(-50%);
      width: 42px;
      height: 42px;
      border-radius: 100px;
      background-color: ${props => props.theme.color.subColor};
      &::before {
        display: none;
      }
      &::after {
        top: 50%;
        left: 50%;
        width: 8px;
        height: 14px;
        transform: translate(-50%, -50%);
        background-image: url(${chevronButton});
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 100px;
        background-color: transparent;
      }
      &.swiper-button-disabled {
        opacity: 1;
        &::after {
          background-image: url(${disabledChevronButton});
        }
      }
    }
    .swiper-button-prev {
      left: calc(50% - 456px / 2 - 42px / 2 - 20px); // 화면가운데 - 이미지절반만큼 좌측 - 버튼절반만큼 좌측 - 간격만큼 좌측
      &::after {
        transform: translate(-50%, -50%) rotate(180deg);
      }
    }
    .swiper-button-next {
      left: calc(50% + 456px / 2 + 42px / 2 + 20px); // 화면가운데 - 이미지절반만큼 우측 - 버튼절반만큼 우측 - 간격만큼 우측
    }
    .swiper-slide {
      gap: 17px;
    }
    .swiper-pagination {
      gap: 12px;
      top: calc(50% + 392px / 2 + 10px + 60px);
      bottom: auto;
    }
    .swiper-pagination-bullet {
      width: 10px;
      height: 10px;
    }
    .swiper-pagination-bullet-active {
      &-prev,
      &-next {
        width: 8px;
        height: 8px;
      }
    }
    .swiper-wrapper {
      margin-bottom: 30px;
    }
    .swiper-image-wrap,
    .swiper-youtube-wrap {
      width: 456px;
      height: 350px;
    }
    .swiper-title {
      font-size: ${props => props.theme.font.xlarge};
    }
    .swiper-source-button {
      width: 448px;
    }
    .swiper-source {
      padding: 4px 10px;
      font-size: ${props => props.theme.font.large};

      img {
        width: 14px;
        height: 14px;
      }
    }
  }
`
export const PopupSwiperGuideWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  width: 100%;
  height: 100%;
  .modal-bg {
    z-index: 2;
    opacity: 0.8;
  }
  .guide-button {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 100%;
    width: 100%;
    padding: 0 14px 28px 14px;
    background-color: transparent;
    z-index: 2;
  }
  .guide-section {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    height: 33dvh;
    border-radius: 14px;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='14' ry='14' stroke='%232ECADBFF' stroke-width='4' stroke-dasharray='3%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  }
  .icon-guide {
    width: calc((100vw - 78px * 2) * 65 / 219);
    max-width: calc(254px * 65 / 219);
    margin-right: 24px;
  }
  .txt-guide {
    width: calc(100vw - 78px * 2);
    max-width: 254px;
  }
`
